import React from "react";
import {connect} from "react-redux";
import {options} from "./../helpers/CountryList";
import {withRouter} from "react-router-dom";
import {translate} from "react-i18next";
import {numberValueLanding} from "./../redux/actions/userActions";
import Select from 'react-select';

import "./SelectComp.css";

class SelectCompLanding extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            secondOption: null,
            reversed : false
        };

    }

    handleChange = selectedOption => {
        this.setState({selectedOption: selectedOption}, () => this.props.onCurrencyChangedLanding(selectedOption.value, this.props.cur2));
    };
    handleChange2 = secondOption => {
        this.setState({secondOption: secondOption}, () => this.props.onCurrencyChangedLanding(this.props.cur, secondOption.value,));
    };


    numberChangedLanding(e){
        if(e.target.value.length <= 10){
            this.props.onNumberValueLanding(e)} else {return ""}
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (this.props.cur !== nextProps.cur) || (this.props.cur2 !== nextProps.cur2) || (this.props.number!==nextProps.number)
    }

    reverseCurrencies(cur2,cur){
        this.setState({reversed: !this.state.reversed}, () => this.props.onCurrencyChangedLanding(cur2, cur));
    }

    render() {
        const { number, cur, cur2, onCurrencyChangedLanding} = this.props;
        const allCurr = options;

        let optionsOne = this.state.reversed ? allCurr : options;
        let optionsSec = this.state.reversed ? options : allCurr;

        return (
            <div className='selectCur'>

                <label for="__frst_conve_val" className="sections sec1">
                    <input id="__frst_conve_val"
                           type="number"
                           name="amount"
                           aria-label="Value"
                           value={number}
                           className="magicLabels"
                           onChange={(e) => this.numberChangedLanding(e)}
                    />
                </label>

                <Select
                    className={"sections sec2"}
                    value={{value: cur,
                        label: <><span
                            className={`flag_24 ${cur}`}/><span>{cur}</span></>
                    }}
                    aria-label="Currency"
                    onChange={this.handleChange}
                    options={optionsOne}
                />

                <div className="sections sec3"
                     onClick={() => this.reverseCurrencies(cur2, cur)}>
                    <button id="replasecur" className="center-block converter_replasecur" aria-label="convert">
                        <span/>
                    </button>
                </div>
                <Select
                    className={"sections sec4"}
                    value={{value: cur2,
                        label: <><span
                            className={`flag_24 ${cur2}`}/><span>{cur2}</span></>
                    }}
                    aria-label="Currency"
                    onChange={this.handleChange2}
                    options={optionsSec}
                />
            </div>);
    }
}

export default connect(
    state => ({
        cur: state.cur,
        cur2: state.cur2,
        rate: state.rate,
        number: state.number,
        language: state.language
    }),
    dispatch => ({
        onInitialNumberValueLanding: (num) => dispatch(numberValueLanding(num)),
        onNumberValueLanding: (e) => dispatch(numberValueLanding(e.target.value))
    })
)(translate('common')(withRouter(SelectCompLanding)))

